export const useStyles = {
  circleBox: {
    borderRadius: "50%",
    width: { sm: "200px", xs: "120px" },
    height: { sm: "200px", xs: "120px" },
    border: "solid 8px",
    position: "relative",
  },
  icon: {
    position: "absolute",
    top: "-28px",
    right: -25,
    width: { md: "100px", xs: "70px" },
  },
};
